// src/config.js
const config = {
  BASE_URL: "https://apis.houseofprayerapp.co", // <-- replace with your actual backend API base URL
};

export default config;
